import { gql } from "graphql-tag";

import { expect } from "@byloth/exceptions";

import { GraphQLRequest } from "@/services";
import { GraphQLException } from "@/services/graphql/exceptions";
import { ProjectNotFoundException } from "@/exceptions";

export interface ProjectData
{
    id: number;
}
export interface ProjectResponse
{
    id: number;

    name: string;
    coverImage?: string;

    showLeaderboards: boolean;
    showQuizzes: boolean;
    showRealtime: boolean;
    showUsers: boolean;

    apiKey: string;
    authDomain: string;
    databaseUrl?: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
    appCheckKey?: string;

    colyseusServer?: string;

    authToken: string;
}

export default class Project extends GraphQLRequest<{ project: ProjectResponse }> implements ProjectData
{
    public static readonly Query = gql`query project($id: Int!) {
        project(id: $id) {
            id,

            name,
            coverImage,

            showLeaderboards,
            showQuizzes,
            showRealtime,
            showUsers,

            apiKey,
            authDomain,
            databaseUrl,
            projectId,
            storageBucket,
            messagingSenderId,
            appId,
            measurementId,
            appCheckKey,

            colyseusServer,

            authToken
        }
    }`;

    public id: number;

    public jsonWebToken?: string;

    public constructor({ id }: ProjectData, jsonWebToken?: string)
    {
        super();

        this.id = id;

        this.jsonWebToken = jsonWebToken;
    }

    public async execute(): Promise<ProjectResponse>
    {
        let response: { project: ProjectResponse };

        try
        {
            response = await this._mutation(Project.Query, { id: this.id }, { jsonWebToken: this.jsonWebToken });
        }
        catch (error)
        {
            expect(error, GraphQLException, (exc) =>
            {
                if (exc.code === "RECORD_NOT_FOUND")
                {
                    const message = "The project you were working on is no longer available.\n" +
                        "If you think this is a mistake, contact the support team for further assistance.";

                    throw new ProjectNotFoundException(message, exc);
                }
            });

            throw error;
        }

        return response.project;
    }
}
